import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAccessComponentsOnNavigation } from '../redux/reducers/utils/servicesReducers/servicesReducer';

/**
 * Хук для проверки доступа к компонентам при навигации
 * Отслеживает любое изменение маршрута и проверяет, не были ли отозваны права доступа
 * Если количество компонентов изменилось, перезагружает приложение
 */
const useAccessCheckOnNavigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuth } = useSelector((store) => store.auth);
  const previousPathRef = useRef(null);

  useEffect(() => {
    // Не проверяем при первой загрузке или если пользователь не авторизован
    if (!isAuth || previousPathRef.current === null) {
      previousPathRef.current = location.pathname;
      return;
    }

    // Проверяем при любом изменении маршрута
    if (previousPathRef.current !== location.pathname) {
      dispatch(checkAccessComponentsOnNavigation({ 
        requestTimestamp: Date.now() 
      }));
    }

    previousPathRef.current = location.pathname;
  }, [location.pathname, isAuth, dispatch]);
};

export default useAccessCheckOnNavigation;
